module.exports = __webpack_public_path__ + "img/background_fallback.24dad3b9.jpg";